<template>
  <div class="loader-overlay">
    <div class="terminal-container">
      <div class="terminal-text">
        {{ displayText }}<span class="cursor">|</span>
      </div>
    </div>
    <span class="text-xs">Caricamento...</span>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const displayText = ref('')
const isTyping = ref(true)
const charIndex = ref(0)
const targetWord = 'lory'
let timeout = null

const typeLoop = () => {
  if (isTyping.value) {
    if (charIndex.value < targetWord.length) {
      displayText.value = targetWord.substring(0, charIndex.value + 1)
      charIndex.value++
      timeout = setTimeout(typeLoop, 150) // ritmo di scrittura
    } else {
      timeout = setTimeout(() => {
        isTyping.value = false
        typeLoop()
      }, 1500) // pausa prima di cancellare
    }
  } else {
    if (charIndex.value > 0) {
      displayText.value = targetWord.substring(0, charIndex.value - 1)
      charIndex.value--
      timeout = setTimeout(typeLoop, 200) // ritmo di cancellazione
    } else {
      timeout = setTimeout(() => {
        isTyping.value = true
        typeLoop()
      }, 800) // pausa prima di riscrivere
    }
  }
}

onMounted(() => {
  typeLoop()
})

onUnmounted(() => {
  if (timeout) clearTimeout(timeout)
})
</script>


<style scoped>

.loader-overlay {
  position: fixed;
  flex-direction: column;
  gap: 16px;
  inset: 0;
  width: 100%;
  height: 100%;
  color: #00ff88;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}


.terminal-text {
  font-family: 'Courier New', 'Monaco', 'Menlo', monospace;
  font-size: 3rem;
  line-height: 3rem;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  animation: glow-pulse 2s ease-in-out infinite;
  letter-spacing: 0.1em;
  user-select: none;
}

.terminal-text::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  pointer-events: none;
}

.cursor {
  animation: cursor-blink 1s step-end infinite;
  width: 10px !important
}


@keyframes cursor-blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

@media (max-width: 768px) {
  .terminal-text {
    font-size: 2rem;
  }
  
  .terminal-container {
    padding: 1.5rem 2rem;
    margin: 1rem;
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .terminal-text {
    font-size: 1.5rem;
  }
  
  .terminal-container {
    padding: 1rem 1.5rem;
  }
}
.terminal-text {
  animation: container-glow 3s ease-in-out infinite alternate;
}
</style>